import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'

const SkipLink: FC = (): ReactNode => {
    return (
        <a
            href='#main'
            className='hud sr-only z-[60] bg-ink px-4 py-3 text-background focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
        >
            Skip to content
        </a>
    )
}

export const Layout: FC<LayoutProps> = ({ children, variant = 'page' }): ReactNode => {
    const home = variant === 'home'

    return (
        <div className='relative flex min-h-svh flex-col'>
            <SkipLink />
            <SiteHeader overlay={home} />

            <main id='main' tabIndex={-1} className={home ? 'flex-1 outline-none' : 'flex-1 pt-14 outline-none desk:pt-16'}>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
